<!-- <nav compact tuiSubheader [style.position]="'sticky'" class="bg-white">
  <tui-breadcrumbs [itemsLimit]="10">
    <ng-container *ngFor="let item of [{ label: 'Dashboard', link: '/admin' }, { label: 'Manual Records', link: '/admin/manual-records' }, { label: isEditMode ? 'Edit Record' : 'Add New Record' }]">
      <ng-container *ngIf="item.link; else lastBreadcrumb">
        <button *tuiItem tuiLink type="button" (click)="navigate(item.link)">
          {{ item.label }}
        </button>
      </ng-container>
      <ng-template #lastBreadcrumb>
        <strong *tuiItem tuiFade>{{ item.label }}</strong>
      </ng-template>
    </ng-container>
  </tui-breadcrumbs>
</nav> -->

<tui-loader 
  [overlay]="true" 
  [showLoader]="isLoading && isEditMode" 
  class="w-full block min-h-[400px]"
>

<section class="w-full">
  <p class="text-4xl font-normal mt-[0.9rem]">
    {{ isEditMode ? 'Edit Extra Charge or Procedure' : 'Add Extra Charge or Procedure' }}
  </p>

  <form [formGroup]="manualRecordForm" (ngSubmit)="submitForm()" novalidate>
    <div class="flex flex-col flex-wrap mt-5">
      <div class="w-full xl:w-1/3 2xl:w-1/3 pr-8 space-y-5">

        <label *ngIf="isEditMode" tuiLabel>
          <tui-input [disabled]="true" formControlName="chargeRefNo">
            Charge Reference No *
          </tui-input> 
        </label>
      
      
      
        <label tuiLabel>
          <tui-input formControlName="clientName">
            Patient Name *
          </tui-input>
          <div *ngIf="manualRecordForm.get('clientName')?.invalid && manualRecordForm.get('clientName')?.touched" class="text-red-500 text-sm mt-1">
            Patient Name is required
          </div>
        </label>
      
        <label tuiLabel>
          <tui-input formControlName="clientAddress">
            Client Address
          </tui-input>
          <app-recommended-hint
            [control]="manualRecordForm.get('clientAddress')"
            message="Recommended. You can save without it and update later."
          />
        </label>
      
        <label tuiLabel>
          <tui-input formControlName="clientContact">
            Client Contact *
          </tui-input>
          <div *ngIf="manualRecordForm.get('clientContact')?.invalid && manualRecordForm.get('clientContact')?.touched" class="text-red-500 text-sm mt-1">
            Client Contact is required
          </div>
        </label>
         
        <label tuiLabel>
          <tui-input formControlName="doctorName">
            Doctor Name
          </tui-input>
        </label>

        <label tuiLabel>
          <tui-input formControlName="nurseName">
            Senior Nurse Name *
          </tui-input>
          <div *ngIf="manualRecordForm.get('nurseName')?.invalid && manualRecordForm.get('nurseName')?.touched" class="text-red-500 text-sm mt-1">
            Senior Nurse Name is required
          </div>
        </label>
      
        <div class="mb-4">
          <tui-combo-box
            [stringify]="stringifyProcedure"
            [(ngModel)]="selectedProcedure"
            (ngModelChange)="onProcedureDropdownChange($event)"
            [ngModelOptions]="{standalone: true}"
            class="w-full"
          > Procedures & Services
            <tui-data-list-wrapper *tuiDataList [items]="procedureOptions" [itemContent]="stringifyProcedure | tuiStringifyContent">
            </tui-data-list-wrapper>
          </tui-combo-box>
          <div *ngIf="manualRecordForm.get('procedures')?.invalid && manualRecordForm.get('procedures')?.touched" class="text-red-500 text-sm mt-1">
            At least one procedure is required
          </div>
        </div>

        <!-- Add new procedure section -->
        <div *ngIf="showAddNewProcedure" class="mt-4 p-4 border border-gray-200 rounded-lg bg-gray-50">
          <div class="flex items-center gap-2">
            <tui-input
              [(ngModel)]="newProcedure"
              [ngModelOptions]="{standalone: true}"
              class="flex-1"
              (keydown.enter)="addNewProcedure()"
            > Add New Procedure</tui-input>
            <button
              tuiButton
              type="button"
              appearance="secondary"
              size="s"
              (click)="addNewProcedure()"
              [disabled]="!newProcedure.trim()"
            >
              Add
            </button>
          </div>
        </div>

        <!-- Selected procedures display -->
        <div *ngIf="manualRecordForm.get('procedures')?.value?.length > 0" class="mt-4">
          <h4 class="text-sm font-medium text-gray-700 mb-2">Procedures & Services:</h4>
          <div class="flex flex-wrap gap-2">
            <span
              *ngFor="let procedure of manualRecordForm.get('procedures')?.value"
              class="inline-flex items-center px-3 py-1 rounded-full text-sm bg-blue-100 text-blue-800"
            >
              {{ procedure }}
              <button
                type="button"
                (click)="removeProcedure(procedure)"
                class="ml-2 text-blue-600 hover:text-blue-800 border-none bg-transparent p-0 cursor-pointer"
              >
                ×
              </button>
            </span>
          </div>
        </div>
      
        <!-- Payment Fields -->
        <div class="mb-6">
          <h3 class="text-lg font-medium text-gray-700 mb-4">Payment Details</h3>
          
          <div formGroupName="payments" class="grid grid-cols-1 gap-4">
            <label tuiLabel>
              <tui-input formControlName="doctorPayment">
                Doctor Charges
                <input tuiTextfieldLegacy type="number" min="0" step="0.01" />
              </tui-input>
            </label>
            
            <label tuiLabel>
              <tui-input formControlName="nursingPayment">
                Nursing Charges
                <input tuiTextfieldLegacy type="number" min="0" step="0.01" />
              </tui-input>
            </label>
            
            <label tuiLabel>
              <tui-input formControlName="pharmacyPayment">
                Pharmacy Charges
                <input tuiTextfieldLegacy type="number" min="0" step="0.01" />
              </tui-input>
            </label>
            
            <label tuiLabel>
              <tui-input formControlName="laboratoryPayment">
                Laboratory Charges
                <input tuiTextfieldLegacy type="number" min="0" step="0.01" />
              </tui-input>
            </label>
            
            <label tuiLabel>
              <tui-input formControlName="ambulancePayment">
                Ambulance Charges
                <input tuiTextfieldLegacy type="number" min="0" step="0.01" />
              </tui-input>
            </label>
            
            <label tuiLabel>
              <tui-input formControlName="physiotherapyPayment">
                Physiotherapy Charges
                <input tuiTextfieldLegacy type="number" min="0" step="0.01" />
              </tui-input>
            </label>
            
            <label tuiLabel>
              <tui-input formControlName="otherPayment">
                Other Charges
                <input tuiTextfieldLegacy type="number" min="0" step="0.01" />
              </tui-input>
            </label>
          </div>

          <!-- Custom Payment Types -->
          <div class="mt-4 p-4 border border-gray-200 rounded-lg bg-gray-50">
            <div class="flex items-center gap-2">
              <tui-input
                [(ngModel)]="newPaymentName"
                [ngModelOptions]="{standalone: true}"
                placeholder="Payment name..."
                class="flex-1"
              > Add Custom Charges name</tui-input>
              <tui-input
                [(ngModel)]="newPaymentValue"
                [ngModelOptions]="{standalone: true}"
                placeholder="Amount..."
                class="w-32"
              > Charges
                <input tuiTextfieldLegacy type="number" min="0" step="0.01" />
              </tui-input>
              <button
                tuiButton
                type="button"
                appearance="secondary"
                size="s"
                (click)="addCustomPayment()"
                [disabled]="!newPaymentName.trim() || !newPaymentValue || newPaymentValue <= 0"
              >
                Add
              </button>
            </div>
          </div>

          <!-- Custom Payment Fields -->
          <div *ngIf="customPayments.length > 0" class="mt-4">
            <h4 class="text-sm font-medium text-gray-700 mb-2">Custom Payments:</h4>
            <div class="flex flex-wrap gap-2">
              <span
                *ngFor="let payment of customPayments; let i = index"
                class="inline-flex items-center px-3 py-1 rounded-full text-sm bg-green-100 text-green-800 cursor-pointer hover:bg-green-200"
                (click)="editCustomPayment(i)"
                title="Click to edit amount"
              >
                {{ payment.name }}: LKR {{ payment.value | number:'1.2-2' }}
                <button
                  type="button"
                  (click)="removeCustomPayment(i); $event.stopPropagation()"
                  class="ml-2 text-green-600 hover:text-green-800 border-none bg-transparent p-0 cursor-pointer"
                  title="Remove payment"
                >
                  ×
                </button>
              </span>
            </div>
          </div>
          
          <!-- Grand Total -->
          <div class="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <div class="flex justify-between items-center">
              <span class="text-lg font-semibold text-gray-700">Grand Total:</span>
              <span class="text-xl font-bold text-blue-600">
                LKR {{ manualRecordForm.get('grandTotal')?.value | number:'1.2-2' }}
              </span>
            </div>
          </div>
        </div>
      
        <label tuiLabel>
          <tui-input-date formControlName="date">
            Date *
          </tui-input-date>
          <div *ngIf="manualRecordForm.get('date')?.invalid && manualRecordForm.get('date')?.touched" class="text-red-500 text-sm mt-1">
            Date is required
          </div>
        </label>
      
      </div>
      
    </div>

    <div class="mt-10 flex justify-end space-x-5">
      <button tuiButton appearance="primary" type="submit" [disabled]="isLoading "
        [appDisableUnlessPermission]="isEditMode ? 'EXTRA_CHARGES_UPDATE' : 'EXTRA_CHARGES_CREATE'">
        {{ isEditMode ? 'Update Record' : 'Create Record' }}
      </button>
    </div>
  </form>
</section>
</tui-loader>

